import script from "./CasesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CasesPage.vue?vue&type=script&setup=true&lang=js"

import "./CasesPage.vue?vue&type=style&index=0&id=af1cd03e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af1cd03e"]])

export default __exports__